import * as React from "react";
import classNames from "classnames";
import {Field, Form} from "react-final-form";
import styles from "./CargaDocumental.module.scss";
import {TiposArchivoPermitidos, URLs} from "../../util/Constants";
import CargaDocumentalForm from "./CargaDocumentalForm";
import ListCardItem, {
  ListCardItemButtonOpProps,
  ListCardItemButtonProps
} from "../../components/UI/ListCardItem/ListCardItem";
import Dialog from "../../components/UI/Dialog/Dialog";
import {DocumentosUtils} from "../../util/DocumentosUtils";
import NavigationUserCard from "../../components/UI/NavigationUserCard/NavigationUserCard";
import BreadcrumbItem from "../../components/UI/Breadcrumb/BreadcrumbItem";
import FileField from "../../components/UI/FileField/FileField";
import LoadingDialog from "../../components/UI/LoadingDialog/LoadingDialog";
import Ilustracion from "../../assets/img/ilustracion.svg";

const moment = require("moment");

export class CargaDocumental extends React.Component<any, any> {

  render() {
    return this.props.solicitud ? (
      <div className={classNames("container-fluid", styles.Container)}>

        <NavigationUserCard id="cdAfiliadoUserCard"
                            nombreSolicitante={DocumentosUtils.generarNombrePropietario(this.props.solicitante)}/>

        <BreadcrumbItem to={URLs.CARGA_DOCUMENTAL} text={"Carga documentos"}/>

        <div className="row">
          <div className="col-xl-7 col-lg-7 col-md-6 col-sm-12 col-12">
            <div className={classNames(styles.ContentContainers, styles.TitleContainer)}>
              <label id="cdEntregaDocumentosLbl" className={styles.Title}>Entrega de Documentos</label>
              <label id="cdTipoSolicitudLbl" className={styles.Subtitle}>
                {this.props.solicitud.tipo.descripcion}
              </label>
            </div>
          </div>
        </div>

        <div className="row">
          <div className={classNames(styles.ContentContainers, styles.DescriptionContainer)}>
            <div className={styles.ImgContainer}>
              <img id="cdBienvenidaImg" className={styles.Img} 
              src={Ilustracion} alt=""/>
            </div>
            <label id="cdMensajeBienvenidaLbl" className={styles.Description}>   
              {`¡Bienvenido(a) ${DocumentosUtils.generarNombreBienvenida(this.props.solicitante)}!`}
            </label>
            <label id="cdInfoDocs1Lbl" className={styles.Content}>
              Adjunta tu documentaci&oacute;n completa para poder revisarla.
              Una vez aprobada, se dar&aacute; inicio a tu solicitud.
              <label id="cdInfoDocs2Lbl" className={styles.ContentSmall}>
                Recuerda cargar todos tus documentos para poder enviarlos.
              </label>
            </label>
          </div>
        </div>

        <Form
          onSubmit={this.props.handleSubmit}
          validate={this.props.validateForm}
          mutators={{
            clearDocument: (args, state, utils) => {
              utils.changeValue(state, args[0], () => undefined);
            }
          }}
          render={(finalFormProps) => {
            return (
              <CargaDocumentalForm
                {...finalFormProps}
                docsAfiliado={this.props.docsAfiliado}
                docsEmpleador={this.props.docsEmpleadores}
                docsApoderado={this.props.docsApoderados}
                docsBeneficiario={this.props.docsBeneficiarios}
                docsReclamante={this.props.docsReclamantes}
                docsCurador={this.props.docsCuradores}
                formatos={this.props.formatos}
                docsBeneficiariosPropietarios={this.props.docsBeneficiariosPropietarios}
                docsReclamantesPropietarios={this.props.docsReclamantesPropiertarios}
                docsCuradoresPropietarios={this.props.docsCuradoresPropietarios}
                docsApoderadosPropietarios={this.props.docsApoderadosPropietarios}
                docsEmpleadoresPropietarios={this.props.docsEmpleadoresPropietarios}
                generarFilaDocumento={this.generarFilaDocumento}
                handleGoBack={this.props.goBack}
                disabled={this.props.isSubmitButtonDisabled(finalFormProps.errors)}
                loader={this.props.isLoading()}/>
            );
          }}
        />

        {this.props.showLoad &&
        <LoadingDialog title={"Estamos cargando tus documentos"}>
          <span id="cdEsperaDocumentosSpan">Por favor espera mientras completamos la carga</span>
        </LoadingDialog>
        }

        {this.props.showSuccess &&
        <Dialog id="cdDocumentosEnviadosDlg"
                icon="check-circle"
                title="Documentos enviados"
                onCancel={this.props.goBack}
                onConfirm={this.props.goBack}
                confirmBtnText="Finalizar">
          Tus documentos han sido enviados exitosamente con fecha {moment(this.props.fechaActual)
          .format("DD/MM/YYYY")}. Te notificaremos a trav&eacute;s de tus medios de contacto registrados en
          Protecci&oacute;n en cuanto haya una novedad.
        </Dialog>
        }

        {this.props.showInfo &&
        <Dialog id="infoEnvioDocumentos"
                icon="alert-triangle"
                title="Información"
                onCancel={this.props.goBack}
                onConfirm={this.props.goBack}
                confirmBtnText="Finalizar">
          {this.props.info}
        </Dialog>
        }
        
        {this.props.showError &&
        <Dialog id="cdErrorEnvioDocsDlg"
                icon="alert-triangle"
                title="Error enviando documentos"
                onCancel={this.props.closeDialogs}
                onConfirm={this.props.closeDialogs}
                confirmBtnText="Aceptar">
          Ocurri&oacute; un error al enviar los documentos. {this.props.error}
        </Dialog>
        }
      </div>
    ) : "";
  }

  generarFilaDocumento = (doc, values, mutators) => {

    const idDoc = DocumentosUtils.generarIdDocumento(doc);

    const showButtonUploadFile = true;
    let showButtonPrintTemplate = false;

    const buttonUploadFileProps: ListCardItemButtonProps = {
      id: idDoc,
      name: "cdSubirDocBtn" + idDoc,
      text: "Subir"
    };
    let buttonPrintTemplateProps: ListCardItemButtonOpProps = {
      id: "",
      name: "",
      text: "",
    };

    if (doc.urlFormato) {
      showButtonPrintTemplate = true;
      buttonPrintTemplateProps = {
        id: "cdDescargarBtn" + idDoc,
        name: "cdDescargarBtn" + idDoc,
        text: "Descargar formato",
        OnClick: () => this.props.downloadTemplate(doc)
      };
    }
    return (
      <div key={"ROW" + idDoc}>

        <ListCardItem id={idDoc}
                      title={doc.nombre}
                      subtitle={doc.descripcion}
                      button={showButtonUploadFile}
                      buttonProps={buttonUploadFileProps}
                      buttonOp={showButtonPrintTemplate}
                      buttonOpProps={buttonPrintTemplateProps}
                      success={values[idDoc] !== undefined}
                      onUploadCancel={() => mutators.clearDocument(idDoc)}/>

        <Field component={FileField}
               id={idDoc}
               name={idDoc}
               cssClassName={styles.Invisible}
               allowedMimeTypes={TiposArchivoPermitidos}/>

      </div>
    );
  }
}

export default CargaDocumental;
